<template>
    <!-- Sign In Start -->
    <div class="login-page d-flex align-items-center justify-content-center">
        <div class="login-card">
            <div class="text-center mb-4">
                <h4 class="brand mb-1"><i class="fa fa-hashtag me-2"></i>My Stock Profile</h4>
                <p class="text-muted mb-0">Sign in to your account</p>
            </div>

            <form @submit.prevent="login">
                <div class="form-floating mb-3">
                    <input
                        type="text"
                        class="form-control"
                        id="floatingInput"
                        placeholder="User Id"
                        v-model="userId"
                        autocomplete="username"
                    >
                    <label for="floatingInput">User Id</label>
                </div>
                <div class="form-floating mb-4">
                    <input
                        type="password"
                        class="form-control"
                        id="floatingPassword"
                        placeholder="Password"
                        v-model="password"
                        autocomplete="current-password"
                    >
                    <label for="floatingPassword">Password</label>
                </div>
                <button
                    type="submit"
                    class="btn btn-primary py-2 w-100"
                    :disabled="loading || !userId || !password"
                >
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                    {{ loading ? 'Signing in...' : 'Log In' }}
                </button>
            </form>
        </div>
    </div>
    <!-- Sign In End -->
</template>

<script>

import { useAuthStore } from '@/stores';

export default {
  name: 'user-login',
  data() {
    return {
        userId: '',
        password: '',
        loading: false,
    }
  },
  setup() {
    const authStore = useAuthStore();
    return { authStore };
  },
  methods:{
    async login() {
        if (this.loading) return;
        this.loading = true;
        try {
            await this.authStore.login(this.userId, this.password);
        } finally {
            this.loading = false;
        }
    },
  }
}
</script>

<style scoped>
.login-page {
    width: 100%;
    min-height: 100vh;
    background: var(--light);
}

.login-card {
    width: 100%;
    max-width: 380px;
    background: #fff;
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 40px 32px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.brand {
    color: var(--primary);
    font-weight: 600;
}
</style>
